import React from "react";
import { Container, Text, withStyles } from "components/common";
import formatNumber from "utils/formatNumber";


const Rewards = ({ rewards }) => (
  <div className="w-full h-full">
    <Container className="w-full flex-1 h-full px-6 justify-center">
      <div className="flex flex-col items-center text-center">
        <Text title>Your Points</Text>
        <Text className="text-2xl md:text-3xl mt-2" weight="light">
          {rewards && rewards.available_points
            ? formatNumber(rewards.available_points) || 0
            : 0}
        </Text>
        <Text className="hidden" size="text-sm" weight="font-light">
          points
        </Text>
      </div>
    </Container>
  </div>
);

export default withStyles(Rewards);
